__turbopack_context__.v({
  "arrow": "TaskCardList-module__E28ZBq__arrow",
  "badge": "TaskCardList-module__E28ZBq__badge",
  "badgePrimary": "TaskCardList-module__E28ZBq__badgePrimary",
  "badgeSuccess": "TaskCardList-module__E28ZBq__badgeSuccess",
  "badgeWarning": "TaskCardList-module__E28ZBq__badgeWarning",
  "card": "TaskCardList-module__E28ZBq__card",
  "cardBody": "TaskCardList-module__E28ZBq__cardBody",
  "cardHeader": "TaskCardList-module__E28ZBq__cardHeader",
  "cardLabel": "TaskCardList-module__E28ZBq__cardLabel",
  "cardList": "TaskCardList-module__E28ZBq__cardList",
  "cardListVertical": "TaskCardList-module__E28ZBq__cardListVertical",
  "cardRow": "TaskCardList-module__E28ZBq__cardRow",
  "cardTime": "TaskCardList-module__E28ZBq__cardTime",
  "cardTitle": "TaskCardList-module__E28ZBq__cardTitle",
  "cardValue": "TaskCardList-module__E28ZBq__cardValue",
  "container": "TaskCardList-module__E28ZBq__container",
  "containerNoBg": "TaskCardList-module__E28ZBq__containerNoBg",
  "copyButton": "TaskCardList-module__E28ZBq__copyButton",
  "empty": "TaskCardList-module__E28ZBq__empty",
  "fadeIn": "TaskCardList-module__E28ZBq__fadeIn",
  "hash": "TaskCardList-module__E28ZBq__hash",
  "header": "TaskCardList-module__E28ZBq__header",
  "shimmer": "TaskCardList-module__E28ZBq__shimmer",
  "skeleton": "TaskCardList-module__E28ZBq__skeleton",
  "sourceLink": "TaskCardList-module__E28ZBq__sourceLink",
  "title": "TaskCardList-module__E28ZBq__title",
  "viewAll": "TaskCardList-module__E28ZBq__viewAll",
});
